import React from 'react'
import styled from 'styled-components/macro'

const IconWrapper = styled.div`
`

const IconTitle = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-family: "Roboto Flex", sans-serif;
  color: ${(props) => props.color};
  text-align: center;
  padding-top: 12px;
  font-size: 0.95rem;
  letter-spacing: 0.3px;
`

const IconBorder = styled.div`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  border-radius: 50%;
  border: 2px solid ${(props) => props.color};
  display: grid;
  margin: 0 auto;
`

const IconImage = styled.svg`
  width: 45%;
  height: 45%;
  align-self: center;
  justify-self: center;
  fill: ${(props) => props.color};
`

const variants = {
  linkedin: {
    iconPath: <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />,
    title: 'LinkedIn',
    viewBox: '0 0 448 512',
    url: 'https://www.linkedin.com/in/amanda-1502b7253/'
  },
  github: {
    iconPath: <path d="M10.07031,20.50291a1.00008,1.00008,0,0,0-1.18115-.9834c-1.30908.24024-2.96191.27637-3.40137-.958a5.70754,5.70754,0,0,0-1.83691-2.415,1.20073,1.20073,0,0,1-.1665-.10938,1,1,0,0,0-.93067-.64551H2.54883a.99965.99965,0,0,0-1,.99512c-.00391.81543.811,1.33789,1.1416,1.51465a4.4408,4.4408,0,0,1,.92383,1.35937c.36426,1.02344,1.42285,2.57617,4.46582,2.376.001.03516.00195.06836.00244.09863l.00439.26758a1,1,0,0,0,2,0l-.00488-.31836C10.07715,21.4951,10.07031,21.22068,10.07031,20.50291Zm10.667-15.126c.03174-.125.063-.26367.09034-.41992a6.27792,6.27792,0,0,0-.40821-3.293,1.002,1.002,0,0,0-.61572-.58007c-.356-.12012-1.67041-.35645-4.18408,1.25a13.86918,13.86918,0,0,0-6.354,0C6.76221.751,5.45459.9658,5.10205,1.07908a.99744.99744,0,0,0-.63135.584,6.3003,6.3003,0,0,0-.40332,3.35644c.02442.12793.05078.2461.07813.35449A6.26928,6.26928,0,0,0,2.89014,9.20311a8.42168,8.42168,0,0,0,.04248.92187c.334,4.60254,3.334,5.98438,5.42431,6.459-.04345.125-.083.25878-.11816.40039a1.00023,1.00023,0,0,0,1.94238.47851,1.6784,1.6784,0,0,1,.46778-.87793.99947.99947,0,0,0-.5459-1.74512c-3.4541-.39453-4.95362-1.80175-5.1792-4.89843a6.61076,6.61076,0,0,1-.03369-.73828,4.25769,4.25769,0,0,1,.91943-2.71289,3.022,3.022,0,0,1,.1958-.23145.99988.99988,0,0,0,.188-1.02441,3.3876,3.3876,0,0,1-.15527-.55567A4.09356,4.09356,0,0,1,6.1167,3.06346a7.54263,7.54263,0,0,1,2.415,1.17968,1.00877,1.00877,0,0,0,.82764.13282,11.77716,11.77716,0,0,1,6.17285.001,1.00549,1.00549,0,0,0,.83056-.13769,7.572,7.572,0,0,1,2.40528-1.19043,4.03977,4.03977,0,0,1,.0874,1.57812,3.205,3.205,0,0,1-.16895.60743.9999.9999,0,0,0,.188,1.02441c.07715.08691.1543.18066.22363.26855A4.12186,4.12186,0,0,1,20,9.20311a7.03888,7.03888,0,0,1-.0376.77734c-.22021,3.05566-1.72558,4.46387-5.1958,4.85937a1,1,0,0,0-.54541,1.7461,1.63079,1.63079,0,0,1,.46631.9082,3.06079,3.06079,0,0,1,.09229.81934v2.334C14.77,21.2949,14.77,21.78025,14.77,22.00291a1,1,0,1,0,2,0c0-.2168,0-.69238.00977-1.33984V18.31346a4.8815,4.8815,0,0,0-.15479-1.31153,4.25638,4.25638,0,0,0-.11621-.416,6.51258,6.51258,0,0,0,5.44531-6.42383A8.69677,8.69677,0,0,0,22,9.20311,6.13062,6.13062,0,0,0,20.7373,5.37693Z" />,
    title: 'GitHub',
    viewBox: '0 0 24 24',
    url: 'https://github.com/a-well'
  },
  stackoverflow: {
    iconPath: <path d="M290.7 311L95 269.7 86.8 309l195.7 41zm51-87L188.2 95.7l-25.5 30.8 153.5 128.3zm-31.2 39.7L129.2 179l-16.7 36.5L293.7 300zM262 32l-32 24 119.3 160.3 32-24zm20.5 328h-200v39.7h200zm39.7 80H42.7V320h-40v160h359.5V320h-40z" />,
    title: 'Stack Overflow',
    viewBox: '0 0 448 512',
    url: 'https://stackoverflow.com/users/19431842/amanda/'
  },
  cv: {
    iconPath: <path d="m249.17973 328.32402c-9.78758 15.38441-19.17851 30.4337-40.22128 45.05521-11.25687 7.89055-37.16464 23.30604-73.9908 23.30604-70.258325 0-126.9676516-51.07979-126.9676516-140.88446 0-78.48565 53.3447156-140.48607 128.4662816-140.48607 30.4337 0 57.47396 10.52167 77.38654 26.30447 18.41392 14.65033 27.03796 29.30348 34.56291 42.45573l-52.58013 26.27338c-3.76134-8.62631-8.28954-17.64933-19.91259-27.40585-12.78437-10.15549-25.53991-13.15224-36.45998-13.15224-42.821335 0-65.364452 39.82459-65.364452 84.14459 0 58.23852 29.700162 87.14305 65.364452 87.14305 34.5629 0 48.47976-24.0418 57.47396-39.42563l52.24332 26.67235zm184.19409-204.75085h70.62618l-92.03686 265.22153h-67.59667l-90.90435-265.22153h70.62446l54.84337 188.60017z" strokeWidth=".07717" />,
    title: 'Resume pdf',
    viewBox: '0 0 512 512',
    url: 'https://docs.google.com/document/d/13dEd_Euq7IZC_t-qibTTXddNINH07GmdBmZK01XhSc8/edit?usp=sharing'
  }
}

const SocialIcon = ({ variant, showText = false, size = 45, color = 'var(--heading)' }) => {
  if (!variants[variant]) {
    throw new Error('Invalid variant passed to Icon component')
  }

  const { title, iconPath, viewBox, url } = variants[variant]

  return (
    <IconWrapper>
      <a href={url} target="_blank" rel="noopener noreferrer">
        <IconBorder size={size} color={color}>
          <IconImage viewBox={viewBox} color={color}>
            {iconPath}
          </IconImage>
        </IconBorder>
        {showText && (
          <IconTitle color={color} size={size}>
            {title}
          </IconTitle>
        )}
      </a>
    </IconWrapper>
  )
}

export default SocialIcon